import { Button } from '@mui/material';
import React from 'react';
import { APIUtils } from '../../../../utils/apiutils';
import httpClient from '../../../../services/http';
import Swal from 'sweetalert2';
import { useAppointmentDetailsContext } from '../contexts/appointmentdetails.context';
import { confirmBox } from '../../../../utils/utils';

const AcceptRejectBtn = () => {
    const { appointmentDetails, setAppointmentDetails } = useAppointmentDetailsContext();

    const updateStatus = (status) => async () => {
        let text = '';
        if (status === 'CONFIRMED') text = 'You want to Accept?';
        else if (status === 'CANCELLED') text = 'You want to Decline?';
        let icon = status === 'CONFIRMED' ? 'info' : 'warning';
        if (await confirmBox(text, 'Are you sure?', icon)) {
            const url = APIUtils.getAdminAPIEndpoint('appointments');
            await httpClient.put(url + `/${appointmentDetails.id}`, { status });
            setAppointmentDetails(prev => ({...prev, status}));
            const message = `${status} Successfully!`;
            Swal.fire('Status!', message, 'success');
            // handleClose();
            // refresh();
        }
    };

    return (
        <>
            <Button variant='contained' color='error' onClick={updateStatus('CANCELLED')}>Reject</Button>
            <Button variant='contained' color='success' onClick={updateStatus('CONFIRMED')}>Accept</Button>
        </>
    );
};

export default AcceptRejectBtn;